import {object, string, array} from 'yup';
import type {UIResourceType} from '@wellstone-solutions/common/models/rest';

// Mirrors Navigator's `modules/resources/v2/components/ResourceForm/schema.js`,
// rewritten for the yup validation engine Bridge's forms use.
//
// Only `title` is required. Email/website are validated for shape when
// present; the API additionally verifies them asynchronously and reports the
// outcome back on `resource.validation` (see `parseValidation` below).
export const resourceSchema = object({
  title: string().required('Title is required').default(''),
  subtitle: string().default(''),
  description: string().default(''),
  email: string().email('Invalid email address').default(''),
  phoneNumber: string().default(''),
  website: string().url('Invalid website URL').default(''),
  dateTimeInformation: string().default(''),
  collections: array().default([]),
  // A resource need not have a location at all — `Resource.Factory()` starts it
  // as null and `toApiInput` sends null through, so the shape has to stay
  // nullable or an untouched form would fail validation.
  location: object({
    address: string().default(''),
    address2: string().default(''),
    city: string().default(''),
    state: string().default(''),
    zipcode: string().default(''),
  })
    .nullable()
    .default(null),
});

export const SUBTITLE_HELPER_TEXT =
  'Words that identify the resource service or sector. (e.g. "Public transportation services" or "Counseling & therapy")';

// The API verifies contact details out of band and hands the result back on
// the saved resource. Surface those as non-blocking field-level messages.
export const parseValidation = (
  validation: UIResourceType['validation'],
): Record<string, string> => {
  if (!validation) {
    return {};
  }

  const errors: Record<string, string> = {};

  if (!validation.emailValid) {
    errors.email = 'Unable to verify email address';
  }

  if (!validation.phoneNumberValid) {
    errors.phoneNumber = 'Unable to verify phone number';
  }

  if (!validation.websiteValid) {
    errors.website = 'Unable to verify website';
  }

  if (!validation.addressValid) {
    errors.address = 'Unable to verify address';
  }

  return errors;
};
